enum DeliveryAddressType {
  'Physical address' = 'physical_address',
  'Different mailing address' = 'different_address',
  'Nova Poshta' = 'express_delivery_address',
}

export default DeliveryAddressType;
